import styled, {
  css
} from 'styled-components'

// Wrapper
export const TemplateBaseWrapper = styled.div`
  /* Parent
  ------------------------------- */
  ${props => {
    const theme = props.theme
    return css`
      /* xxxxx: ${theme.xxxxx}; */
    `
  }}

  /* Childrens
  ------------------------------- */
  /* Modifiers
  ------------------------------- */
  /* Media queries
  ------------------------------- */
`
